import { isFinanceProject } from 'config';
import { CompanyName } from 'modules/onboarding/common/components';

import { useCompanyName } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const CompanyNameStep = ({ canGoBack }: PageComponentProps) => {
  const { initialValues, onSubmit, submitLoading, goToBack } = useCompanyName();
  const { step } = useOnboardingContext();
  return (
    <CompanyName
      canGoBack={canGoBack}
      enabledShortName={isFinanceProject()}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
